import React from 'react';
import './schedule.scss';

export const ScheduleTitle = (props) => {
    return(
        <div className="schedule-title">
            { props.children }
        </div>
    )
} 

export const PanelCalendar = (props) => {
    return(
        <div className="app-panel-calendar">
            { props.children }
        </div>
    )
} 